import { Injectable } from '@angular/core';
import * as tf from '@tensorflow/tfjs';
import { BehaviorSubject, Observable } from 'rxjs';

let model: any;

@Injectable({
  providedIn: 'root'
})
export class MlImageDeduplicationService {

  public _warmingUp: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public warmingUp: Observable<any> = this._warmingUp.asObservable();

  modelLoaded = false;

  constructor() {}

  public async loadModel() {
    const options = {
      strict: false
    };
    const modelUrl = 'assets/models/dedup.json';
    model = await tf.loadGraphModel(modelUrl, options);
    this.modelLoaded = true;
  }

  async warmUp() {
   // Made to heat up the model, but breaks UI
   this._warmingUp.next(true);
    const result = await model.predict(
      { 'img1_input': tf.zeros([1, 224, 224, 3]), 'img2_input': tf.zeros([1, 224, 224, 3]), 'time_input': this.deltaPreprocess(0)});
    await result;
    this._warmingUp.next(false);
  }


  start(image1, image2, delta_t_sec): any {
    let result;
    if (delta_t_sec === 0) {
      delta_t_sec = 18;
    }
    const max_t = 600;
    delta_t_sec = Math.min(Math.max(delta_t_sec, 0), max_t);
    const delta_t = Math.log(delta_t_sec + 1) / Math.log(max_t + 1);
    const nRepeats = 1;
    for (let i = 0; i < nRepeats; i++) {
      tf.tidy(() => {
        result = this.predict(image1, image2, delta_t);
    });
    }
    return result;
  }

  predict(img1, img2, delta_t) {
      const img1_proc = this.preprocess(img1);
      const img2_proc = this.preprocess(img2);
      const delta_t_tensor = this.deltaPreprocess(delta_t);
      const input = { 'img1_input': img1_proc, 'img2_input': img2_proc, 'time_input': delta_t_tensor };
      let pred;
      pred = model.predict(input);
      pred = pred.data();
      return pred;
  }

  deltaPreprocess(delta_t) {
    const delta_t_tensor = tf.tensor([delta_t]);
    return delta_t_tensor.expandDims(0);
  }

  preprocess(img) {
    const tensor = tf.browser.fromPixels(img)
      .resizeNearestNeighbor([224, 224])
      .toFloat()
      .expandDims();
    return tensor;
  }

}

